// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
import { createIllustration } from '@atlassian/jira-illustration/src/ui/index.tsx';
import type {
	AsImgProps,
	IllustrationFn,
	SVGViewBox,
} from '@atlassian/jira-illustration/src/ui/types.tsx';
import srcDark from '../../assets/ui-jsw-compass-crossflow.svg'; // eslint-disable-line import/no-duplicates, jira/import/no-duplicates
import srcLight from '../../assets/ui-jsw-compass-crossflow.svg'; // eslint-disable-line import/no-duplicates

const Illustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
});

export default Illustration;

// for advanced use only
const viewBox: SVGViewBox = [0, 0, 64, 64];
export { viewBox };
